import React, { Component } from 'react'
import { Provider } from 'react-redux'
import Router from '../root/routes.js'
import App from '../root/App.js'

export default class Root extends Component {
  render () {
    const { store } = this.props
    return (
      <Provider store={store}>
        <Router component={App} />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./client/src/root/Root.js